import React from 'react';
import PropTypes from 'prop-types';

const Camera = ({ fill = 'var(--PRIMARY)', className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    className={className}
  >
    <path
      d="M9.59 1.75L11 3.25H14V12.25H2V3.25H5.0375L6.41 1.75H9.59ZM10.25 0.25H5.75L4.3775 1.75H2C1.60218 1.75 1.22064 1.90804 0.93934 2.18934C0.658035 2.47064 0.5 2.85218 0.5 3.25V12.25C0.5 12.6478 0.658035 13.0294 0.93934 13.3107C1.22064 13.592 1.60218 13.75 2 13.75H14C14.3978 13.75 14.7794 13.592 15.0607 13.3107C15.342 13.0294 15.5 12.6478 15.5 12.25V3.25C15.5 2.85218 15.342 2.47064 15.0607 2.18934C14.7794 1.90804 14.3978 1.75 14 1.75H11.6225L10.25 0.25ZM8 5.5C8.44501 5.5 8.88002 5.63196 9.25003 5.87919C9.62004 6.12643 9.90843 6.47783 10.0787 6.88896C10.249 7.3001 10.2936 7.7525 10.2068 8.18895C10.12 8.62541 9.90566 9.02632 9.59099 9.34099C9.27632 9.65566 8.87541 9.86995 8.43895 9.95677C8.0025 10.0436 7.5501 9.99903 7.13896 9.82873C6.72783 9.65843 6.37643 9.37004 6.12919 9.00003C5.88196 8.63002 5.75 8.19501 5.75 7.75C5.75 7.15326 5.98705 6.58097 6.40901 6.15901C6.83097 5.73705 7.40326 5.5 8 5.5ZM8 4C7.25832 4 6.5333 4.21993 5.91661 4.63199C5.29993 5.04404 4.81928 5.62971 4.53545 6.31494C4.25162 7.00016 4.17736 7.75416 4.32206 8.48159C4.46675 9.20902 4.8239 9.8772 5.34835 10.4017C5.8728 10.9261 6.54098 11.2833 7.26841 11.4279C7.99584 11.5726 8.74984 11.4984 9.43506 11.2145C10.1203 10.9307 10.706 10.4501 11.118 9.83339C11.5301 9.2167 11.75 8.49168 11.75 7.75C11.75 6.75544 11.3549 5.80161 10.6517 5.09835C9.94839 4.39509 8.99456 4 8 4Z"
      fill={fill}
    />
  </svg>
);

Camera.propTypes = {
  fill: PropTypes.string,
  className: PropTypes.string,
};

export default Camera;
